// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".primaryNav__wrapper--ViQQl {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/nav/primaryNav/primaryNav.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".wrapper {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "primaryNav__wrapper--ViQQl"
};
module.exports = ___CSS_LOADER_EXPORT___;
